import { Form, Radio, Space } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../Icon"
import ButtonComponent from "../Button"
import InputComponent from "../Input"

const list = [
  "Search Engine (Google, Bing, etc.)",
  "Marketplace (G2, ProductHunt, etc.)",
  "Email",
  "App marketplace (Stripe App Marketplace, Shopify App Store, etc.)",
  "Social media",
  "Award ceremonies",
  "Through a friend",
  "Blog",
  "Other"
]
function QuestionsForm({ form, onSubmit }) {
  const { t } = useTranslation()

  const onFinish = (values) => {
    onSubmit(values)
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
  }

  function onFocusHandler(e) {
    handleClearError(e, e.target.name)
  }

  const addErrorIcon = (error) => (
    <span>
      <Icon type={"alert_triangle_error"} /> {t(error)}
    </span>
  )

  return (
    <Form
      className={"with-default-error"}
      onFinish={onFinish}
      validateTrigger="onSubmit"
      layout="vertical"
      form={form}
      requiredMark={false}
    >
      <Form.Item
        label=""
        name="answer"
        rules={[
          {
            required: true,
            message: addErrorIcon("Required fields were not filled.")
          }
        ]}
      >
        <Radio.Group name="answer" onChange={onFocusHandler}>
          <Space direction="vertical" size={16}>
            {list.map((el) => (
              <Radio key={el} value={el}>
                {t(el)}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) => prevValues.answer !== currentValues.answer}
      >
        {({ getFieldValue }) =>
          getFieldValue("answer") === "Other" ? (
            <Form.Item
              name="other_details"
              rules={[
                {
                  required: true,
                  message: addErrorIcon("Required fields were not filled.")
                }
              ]}
            >
              <InputComponent
                placeholder={t("I found you on...")}
                name="other_details"
                //onChange={e => handleClearError(e, 'name')}
                onFocus={onFocusHandler}
              />
            </Form.Item>
          ) : null
        }
      </Form.Item>

      <ButtonComponent
        type="primary"
        size="large"
        htmlType="submit"
        className="btn-primary_animation"
        block
        style={{ marginTop: 16 }}
      >
        {t("Continue")}
      </ButtonComponent>
    </Form>
  )
}

export default QuestionsForm
